import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
const languageMap = {
  zh: "zh-CN",
  en: "en-US"
};
const setLanguage = (language) => {
  const currentLanguage = languageMap[language];
  if (!currentLanguage) return;
  roomService.setLanguage(currentLanguage);
};
export {
  setLanguage
};
